import { Theme } from '@abiglobalhealth/go-types'
import { useContext } from 'react'

import { ConfigContext } from '@/contexts/config'

interface UseThemeProps {
  theme: Theme | undefined
}

export const useTheme = (): UseThemeProps => {
  const { config } = useContext(ConfigContext)

  return {
    theme: config?.theme
  }
}
